/**************************************************************************************************/
/*   File: /src/app/shared/models/language.ts                                                     */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Thursday January 24th 2019                                                     */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
/**
 * The language
 */
export class Language {
    /**
     * The isoCode
     */
    isoCode: string;

    /**
     * True if language is selected
     */
    selected: boolean;

    /**
     * The contructor
     * @param isoCode The isoCode
     */
    constructor(isoCode: string) {
        this.isoCode = isoCode;
        this.selected = false;
    }
}